import styled from 'styled-components';

import { LabelS } from '@sorare/core/src/atoms/typography';
import { FilterWidget, FiltersGroup } from '@sorare/core/src/lib/filters';

import { MobileFilterWidget } from '../MobileFilterWidget';

const Group = styled.div`
  &:not(:has(.isActiveWidget)) {
    display: none;
    & .group-title {
      display: none;
    }
  }
  &:has(.showTitle) {
    display: block;
    & .group-title {
      display: block;
    }
  }
`;

const GroupTitle = styled(LabelS)`
  &:not(:has(.isActiveWidget)) {
    display: none;
  }
  &:has(.showTitle) {
    display: block;
  }
  margin-bottom: var(--half-unit);
`;

const GroupWrapper = styled.div`
  overflow: hidden;
  border-radius: var(--unit);
  box-shadow: inset 0px 0px 0px 1px var(--c-neutral-150);
  &:not(:has(.showTitle)) {
    box-shadow: none;
  }
`;

const Separator = styled.div`
  border-top: 1px solid var(--c-neutral-150);
  margin: 0 var(--unit);
`;

export const MobileFilters = ({
  filters,
  onClick,
  activeWidget,
}: {
  filters: FiltersGroup[];
  onClick: (f: FilterWidget) => void;
  activeWidget?: FilterWidget;
}) => {
  return (
    <>
      {filters.map(filtersGroup => {
        return (
          <Group key={filtersGroup.slug}>
            {filtersGroup.title && (
              <GroupTitle
                uppercase
                bold
                color="var(--c-neutral-600)"
                className="group-title"
              >
                {filtersGroup.title}
              </GroupTitle>
            )}

            {filtersGroup.filter ? (
              filtersGroup.filter.Component({ visible: true })
            ) : (
              <GroupWrapper>
                {filtersGroup.filters.map((filter, ii) => {
                  const key =
                    filter.type === 'separator'
                      ? `separator-${ii}`
                      : filter.key;
                  if (filter.type === 'separator') {
                    return <Separator key={key} />;
                  }
                  return (
                    <MobileFilterWidget
                      key={key}
                      widget={filter}
                      onClick={() => onClick(filter)}
                      activeWidget={activeWidget}
                    />
                  );
                })}
              </GroupWrapper>
            )}
          </Group>
        );
      })}
    </>
  );
};
